import { Granularity, TimeRangeConfig } from '@/api/generated/model';
import { SwitcherItem } from '@/comps/ui/buttons/UISwitcher/types';
import { UserIntelligenceView } from '@/domains/home/components/home-tabs/user-intelligence/page';
import { SelectItemType } from '@/types/userIntell/chartView';
import { getTimeRangeDiff } from '@/utils/granularity';
import { Eye, EyeOff, Globe, LineChart, Table } from 'lucide-react';
import { translateSafe } from '@/utils/translations';

export const selectItemIconSize = 14;

export const getGranularitySelectItems = (timeRange?: TimeRangeConfig): SelectItemType<Granularity>[] => {
  const hourDiff = 60 * 60;
  if (timeRange?.kind === 'custom' && getTimeRangeDiff(timeRange) < hourDiff)
    return [{ value: 'minute', title: 'Minute' }];
  return [
    { value: 'hour', title: translateSafe('time', 'hour') },
    { value: 'day', title: translateSafe('time', 'day') },
    { value: 'week', title: translateSafe('time', 'week') },
    { value: 'month', title: translateSafe('time', 'month') },
    { value: 'year', title: translateSafe('time', 'year') },
  ];
};

export function getUserIntelligenceViewItems(): SwitcherItem<UserIntelligenceView>[] {
  return [
    { value: 'table', label: translateSafe('userIntelligence', 'table'), icon: Table },
    { value: 'map', label: translateSafe('userIntelligence', 'map'), icon: Globe },
    { value: 'chart', label: translateSafe('userIntelligence', 'chart'), icon: LineChart },
  ];
}

export type UserIntelligenceDetailsView = 'user-query' | 'interactions';
export const DEFAULT_USER_INTELLIGENCE_DETAILS_VIEW: UserIntelligenceDetailsView = 'user-query';

export function getActionDetailsSwitchItems(): SwitcherItem<UserIntelligenceDetailsView>[] {
  return [
    { value: 'user-query', label: translateSafe('userIntelligence', 'hide'), icon: EyeOff },
    { value: 'interactions', label: translateSafe('userIntelligence', 'show'), icon: Eye },
  ];
}
